import React, { createRef } from "react";
import { isValidReference } from "mobx-state-tree";
import {
	Modal,
	Button,
	Menu,
	Icon,
	Input,
	Loader,
	Radio,
	Dropdown,
} from "semantic-ui-react";
import moment from "moment";
import { observer, inject } from "mobx-react";
import { withTranslation } from "react-i18next";
import { arrayFilter } from "../../../helpers/calendar.js";
import ResMapDetail from "./resMapDetail";
import Nagel from "../../../images/logo-nagel.png";
import uuid from "uuid";
import AddRentalResource from "./addRentalResource.js"; 

/*

Ressource wird dann als disponiert angezeigt, wenn die Ressource auf allen Jobs disponiert ist
Ressource wird dann als nicht verfügbar angezeigt, wenn sie während eines der Jobs wo anders ist, ausgenommen einer der Jobs
Zielpunkt der Ressourcenkarte ist der erste der gewählten Jobs
Startpunkt der Ressourcenkarte ist vorherige disponierte Job der Ressource

*/

class ResourceChooser extends React.Component {
	constructor(props) {
		super(props);
		this.state = ResourceChooser.initialState;
		this.onScroll = this.onScroll.bind(this);
		this.saveRentalResource = this.saveRentalResource.bind(this); 
	}

	static initialState = {
		filter: "",
		selected: [],
		selectedClass: "",
		activeMap: "",
		marker: false,
		rentalResources: {},
		disposed: new Map(),
		firstPosition: null,
		initiallySelected: [],
		resourceInformation: false,
		jobs: [],
		showUnavailable: false,
		nagel: false,
		project: null,
		filterRoller: true,
		showFilerRollerRadio: false,
		rollerShowDefault: [],
		processes: [],
		currentProcess: "",
		selectedIndividualProcess: [],
		multiMode: false,
		selectedProcesses: [],
		deploymentDetails:[]
	};

	componentDidUpdate(prevProps) {
		
		if (!this.props.open && prevProps.open) {
			this.setState(ResourceChooser.initialState);
		} else if (this.props.open && !prevProps.open) {
			setTimeout(
				(x) =>
					this.setState(
						ResourceChooser.load(
							this.props.app.projects.getJobs(this.props.selectedJobs),
							this.props.app.resources.classes,
							this.props.app.resources.groups,
							this.props.requirement,
							this.props.app.orders.deployments,
							this.props.selectedJobs,
							this.props.onlyDrivers
						)
					),
				5
			);
		}
	}

	static jobOverlaps(x, y) {
		return x.start <= y.end && y.start <= x.end;
	}

	static load(jobs, classes, groups, requirement,deployments,selectedJob,onlyDrivers) {
		let firstJob = null;
		const selected = [];
		const jobIds = new Set();
		const intervals = [];
		const jobsOut = [];
		let project = null;
		let showFilerRollerRadioState = false;
		let rollerResIds = [];
		let processes = {}; 
		let currentProcess = false;
		let selectedIndividualProcess = {};

		//get first jobs location
		for (let job of jobs) {
			if (job.deleted) continue;
			if (
				requirement.id &&
				typeof job.openRequests.find(
					(x) => x.requirement.id === requirement.id
				) === "undefined"
			)
				continue;
			if (firstJob === null || firstJob.start > job.start) {
				firstJob = job;
			}
			project = job.project;
			jobIds.add(job.id);
			intervals.push({ start: job.start, end: job.end });
			jobsOut.push(job);

			const processId = job._process.id; 
			currentProcess = currentProcess || processId;
			if (!(processId in processes)) {
				processes[processId] = job._process; 
				selectedIndividualProcess[processId] = { resources: [], jobs: [] }; 
				for (let d of job.$deployments.values()) {
					if (d.deleted || d._resource.deleted || d._resource._resclass.deleted) continue;
					if (d._resGroup && isValidReference(() => d._resGroup) && !selectedIndividualProcess[processId]['resources'].includes("GROUP#" + d._resGroup.id) ) { 
						selectedIndividualProcess[processId]['resources'].push("GROUP#" + d._resGroup.id);
					}	
					selectedIndividualProcess[processId]['resources'].push(d._resource._resclass.id + "#" + d._resource.id);				
				}
				for (let r of job.$rentalDeployments.values()) {
					selectedIndividualProcess[processId]['resources'].push("RENT#" + r._rentalResource.id);
				}
			}
			selectedIndividualProcess[processId]['jobs'].push(job);	

		}
		const position = firstJob !== null ? firstJob.safePosition : null;
		//console.log(requirement);
		const resourceInformation = new Map();
		const groupDispositionCount = {};
		const requirement_additionalClasses = requirement.additionalClasses || [];
		for (let [classid, resclass] of classes) {
			if (resclass.deleted) continue;
			if (
				requirement.id &&
				requirement.resclass.id !== classid &&
				//!requirement.additionalClasses.includes(classid)
				!requirement_additionalClasses.includes(classid)
			)
				continue;
			for (let [resid, res] of resclass.$resources) {
				if (!isValidReference(() => res) || res.deleted) continue;
				if (
					requirement.id &&
					requirement.satisfiedBy !== null &&
					!requirement.satisfiedBy.includes(resid)
				)
					continue;
				//console.log(res.name);
				let disposedCount = 0;
				let nearestJob = null;
				let isAvailable = true;
				let borderColor = null;

				const overlaps = [];
				for (let d of res.$deployments.values()) {
					if (!isValidReference(() => d) || d.deleted || d.job.deleted)
						continue;
					if (jobIds.has(d.job.id)) {
						disposedCount++;
						if (d._resGroup && isValidReference(() => d._resGroup)) {
							if (!(d._resGroup.id in groupDispositionCount))
								groupDispositionCount[d._resGroup.id] = new Set();
							groupDispositionCount[d._resGroup.id].add(d.job.id);
						}
					} else {
						if (
							firstJob &&
							d.job.end <= firstJob.start &&
							(nearestJob === null || nearestJob.end < d.job.end)
						)
							nearestJob = d.job;

						if (!isAvailable) continue;
						for (let interval of intervals) {
							if (ResourceChooser.jobOverlaps(interval, d.job)) {
								//console.log(interval, d.job);
								isAvailable = false;
								overlaps.push(d.job);
								break;
							}
						}
					}
				}
				if (isAvailable) {
					for (let d of res.$absences.values()) {
						if (!isValidReference(() => d) || d.deleted) continue;
						for (let interval of intervals) {
							if (ResourceChooser.jobOverlaps(interval, d)) {
								borderColor = d.type.color;
								isAvailable = false;
								break;
							}
						}
					}
				}
				if (disposedCount >= jobIds.size) {
					//selected.push(classid + "#" + resid);
				}
				resourceInformation.set(classid + "#" + resid, {
					borderColor,
					previousPosition:
						nearestJob !== null ? nearestJob.safePosition : null,
					isAvailable,
					overlappingJobs: overlaps,
				});
			}
		}

		for (let rentalResource of project.$rentalResources.values()) {
			if (!isValidReference(() => rentalResource) || rentalResource.deleted)
				continue;
			let disposedCount = 0;
			//console.log(rentalResource.$rentalDeployments);
			for (let rentalDeployment of rentalResource.$rentalDeployments.values()) {
				if (
					!isValidReference(() => rentalDeployment) ||
					rentalDeployment.deleted
				)
					continue;
				//console.log(rentalDeployment);
				if (jobIds.has(rentalDeployment.job.id)) disposedCount++;
			}
			//console.log(disposedCount);
			if (disposedCount >= jobIds.size) {
				//selected.push("RENT#" + rentalResource.id);
			}
		}

		for (let group of groups.values()) {
			if (
				group.id in groupDispositionCount &&
				groupDispositionCount[group.id].size >= jobIds.size
			) {
				//selected.push("GROUP#" + group.id);
			}
			let isAvailable = true;
			for (let member of group._members.values()) {
				if (
					!isValidReference(() => member) ||
					member.deleted ||
					member.resclass === null ||
					member.resclass.deleted ||
					!resourceInformation.has(member.resclass.id + "#" + member.id)
				)
					continue;
				const rI = resourceInformation.get(
					member.resclass.id + "#" + member.id
				);
				if (rI.isAvailable) continue;
				isAvailable = false;
				break;
			}

			resourceInformation.set("GROUP#" + group.id, {
				previousPosition: null,
				borderColor: null,
				isAvailable: isAvailable,
				overlappingJobs: [],
			});
		}
		if(
			requirement.id !== false && 
			requirement?._resclass?.name.toLowerCase() === "walzen" &&
			jobs.length
		) {
			const rollerReqId = requirement.id;
			const jobRollerData = jobs[0].roller_data;
			if(jobRollerData) {
				if(
					jobRollerData?.rollers?.length && 
					jobRollerData?.roller_resources?.length
				){
					const reqRollerGroup = jobRollerData.rollers.filter(r => r.rollingRequestID === rollerReqId);
					const rollerResourses = jobRollerData.roller_resources;
					if(reqRollerGroup.length){
						const rollerReqWidth = reqRollerGroup[0].rollerBandage;
						const rollerReqSpeed = reqRollerGroup[0].rollerSpeed;
						if(rollerReqWidth && rollerReqSpeed){
							rollerResourses.forEach(res => {								 
								if(rollerReqWidth === res.rollerBandage && rollerReqSpeed === res.rollerSpeed){
									rollerResIds.push(res.resource);
									showFilerRollerRadioState = true;
								}
							})							
						}	
					}
				}				 
			} 
		}

		if(
			requirement.id !== false && 
			requirement?._resclass?.name.toLowerCase() === "walzen" &&
			jobs.length
		) {
			const rollerReqId = requirement.id;
			const jobRollerData = jobs[0].roller_data;
			if(jobRollerData) {
				if(
					jobRollerData?.rollers?.length && 
					jobRollerData?.roller_resources?.length
				){
					const reqRollerGroup = jobRollerData.rollers.filter(r => r.rollingRequestID === rollerReqId);
					const rollerResourses = jobRollerData.roller_resources;
					if(reqRollerGroup.length){
						const rollerReqWidth = reqRollerGroup[0].rollerBandage;
						const rollerReqSpeed = reqRollerGroup[0].rollerSpeed;
						if(rollerReqWidth && rollerReqSpeed){
							rollerResourses.forEach(res => {								 
								if(rollerReqWidth === res.rollerBandage && rollerReqSpeed === res.rollerSpeed){
									rollerResIds.push(res.resource);
									showFilerRollerRadioState = true;
								}
							})							
						}	
					}
				}				 
			} 
		}

		//for each resource iterate over the dispositions and check if it is on another job (not in the list) that is at the same time. also search the previous job nearest to the first to get the start position
		//console.log(resourceInformation);
		
		
		// get resources on same date of other projects
		let deploymentDetails = [];
		
		if(!onlyDrivers && (selectedJob.length === 1 && typeof selectedJob[0] === "string")){
			let deploymentDetail = [];		
			let todaysDate = null;

			const parts = selectedJob[0].split('#');
			todaysDate = parts[parts.length - 1];
			
			const filteredDeployments = Array.from(deployments?.values() ?? []);

			for (let i = 0; i < filteredDeployments.length; i++) {
				const d = filteredDeployments[i];

				deploymentDetail.push({
					projectName: d.project.name,
					resourceId: d._resource?.id,
					resourceName: d._resource?.name,
					process: d._job?._process?.name,
					process_start: d._job?.start,
					process_end: d._job?.end,
				});
			}
			deploymentDetails = deploymentDetail?.filter(d => {
				const startDay = new Date(d.process_start).toISOString().slice(0, 10);
				return startDay === todaysDate;
			})|| [];
		}


		return {
			isOpen: true,
			position,
			selected,
			project,
			initiallySelected: JSON.parse(JSON.stringify(selectedIndividualProcess)), // selected.slice(),
			resourceInformation,
			jobs: jobsOut,
			showFilerRollerRadio: showFilerRollerRadioState,
			rollerShowDefault: rollerResIds,
			processes: Object.values(processes),
			currentProcess,
			selectedIndividualProcess,
			deploymentDetails
		};
	}

	saveRentalResource(id, name, supplier, resclass) {
		if (id) {
			this.state.project.updateRentalResource(id, name, supplier);
		} else {
			this.props.app.projects.updateRentalResources([
				{
					id: uuid.v4(),
					_project: this.state.project.id,
					_resclass: resclass,
					_supplier: supplier,
					name: name,
					comment: "",
				},
			]);
		}
	}

	onScroll() {
		this.setState((prev) => {
			if (prev.marker !== false)
				return {
					marker: false,
				};
			else return null;
		});
	}

	componentDidMount() {}

	changeFilter(filter) {
		this.setState({ filter });
	}

	selectClass(cls) {
		this.setState((prevState) => {
			return {
				selectedClass: prevState.selectedClass === "" ? cls : "",
				activeMap: "",
			};
		});
	}

	nagel(nagel) {
		this.setState({ nagel });
	}

	setShowUnavailable(showUnavailable) {
		this.setState({ showUnavailable });
	}
	
	setCurrentProcess(currentProcess) {
		const { selectedProcesses } = this.state;		
		if(this.state.multiMode){
			this.setState({
				selectedProcesses: selectedProcesses.includes(currentProcess)
				  ? selectedProcesses.filter((id) => id !== currentProcess) 
				  : [...selectedProcesses, currentProcess], 
				activeMap: "", 
				marker: false
			  });		
		} else {
			this.setState({ currentProcess, activeMap: "", marker: false });
		} 
	}

	setMultiModeRes(multiMode) {		
		this.setState((prevState) => ({
			multiMode,
			selectedProcesses: multiMode? [prevState.currentProcess] : [], 
			activeMap: "", 
			marker: false
		}));
	}

	toggle(e, resClass, resource, marked) {
		e.persist(); 
		if (e.target.classList.contains("ignore")) return false;

		let markpos = 0;
		try {
			markpos =
				e.clientX - e.target.closest(".resc_wrapper").getBoundingClientRect().x;
		} catch (e) {
			console.log(e);
		}

		let selectedIndividualProcess;
		const key = resClass + "#" + resource;
		if(this.state.multiMode){
			this.setState((prevState) => {
				const { selectedProcesses, selectedIndividualProcess } = prevState;			
				const updatedSelectedIndividualProcess = { ...selectedIndividualProcess };			
				selectedProcesses.forEach((processId) => {
					if (!(processId in updatedSelectedIndividualProcess)) {
						updatedSelectedIndividualProcess[processId] = { resources: [] };
					}			
					const process = updatedSelectedIndividualProcess[processId];	
					if (!process.resources.includes(key)) {
						process.resources.push(key); 
					} else {
						if(marked.trim() === "marked"){	 		
							process.resources = process.resources.filter((value) => value !== key); 
						}
					}
				});			
				return {
					selectedIndividualProcess: updatedSelectedIndividualProcess,
				};
			});
		} else {
			this.setState(prevState => { 
				let activeMap = "";
				let marker = false;
				selectedIndividualProcess = prevState.selectedIndividualProcess; 
				if (!(prevState.currentProcess in selectedIndividualProcess)) return null;	
				if (!selectedIndividualProcess[prevState.currentProcess]['resources'].includes(key)) {
					selectedIndividualProcess[prevState.currentProcess]['resources'].push(key); 
					activeMap = key;
					marker = markpos;
					 
				} else {
					selectedIndividualProcess[prevState.currentProcess]['resources'] = selectedIndividualProcess[prevState.currentProcess]['resources'].filter(value => value !== key); 
				}				
				return {
					selectedIndividualProcess,
					activeMap,
					marker,
				};
			});
		}
	}	 

	render() {
		if (!this.props.open) return null; 

		if (this.state.nagel !== false) {
			let firstJob = null;
			let lastJob = null;
			for (let job of this.state.jobs) {
				if (job.deleted) continue;
				if (firstJob === null || firstJob.start > job.start) {
					firstJob = job;
				}
				if (lastJob === null || lastJob.end < job.end) {
					lastJob = job;
				}
			}

			return (
				<Modal
					centered={false}
					className="nagelModal"
					open={this.props.open}
					onClose={(e) => this.nagel(false)}
				>
					<Menu>
						<Menu.Item header>
							{this.props.t("resourceChooser.nagel.heading")}
						</Menu.Item>
						<Menu.Menu position="right">
							<Menu.Item name="close it" onClick={(e) => this.nagel(false)}>
								<Icon name="arrow left" /> {this.props.t("back")}
							</Menu.Item>
						</Menu.Menu>
					</Menu>
					<Modal.Content>
						<div
							className="nagelLogo"
							style={{
								backgroundImage: `url(${Nagel})`,
							}}
						/>
						<div className="nagelRow">
							<div className="nagelH">Suchbegriff</div>
							<div className="nagelD">{this.state.nagel}</div>
						</div>
						<div className="nagelRow">
							<div className="nagelH">Mietbeginn</div>
							<div className="nagelD">
								{moment(firstJob.start).format("DD.MM.YYYY")}
							</div>
						</div>
						<div className="nagelRow">
							<div className="nagelH">Mietende</div>
							<div className="nagelD">
								{moment(lastJob.end).format("DD.MM.YYYY")}
							</div>
						</div>
						<div className="nagelRow">
							<div className="nagelH">Ort</div>
							<div className="nagelD">
								{this.state.position !== null
									? this.state.position.lat.toFixed(4) +
									  "," +
									  this.state.position.lng.toFixed(4)
									: "Unbekannt"}
							</div>
						</div>
					</Modal.Content>
				</Modal>
			);
		}

		const rentalResources = this.state.project
			? this.state.project.getRentalResourcesByClass()
			: {};
 

		const filter = arrayFilter(this.state.filter);
		const compactmode =
			!this.props.app.ui.settings.autoExpandResources &&
			(this.state.filter === "" && this.state.selectedClass === "");


		let resourcesBooked;
		return (
			<Modal
				centered={false}
				className="resourceChooserModal"
				open={this.props.open}
				onClose={(e) => this.props.close()}
			>
				{this.state.resourceInformation === false ? (
					<Loader size="large" />
				) : (
					<React.Fragment>
						<Menu color="blue" inverted className="chooserTopMenu">
							<Dropdown
								item
								className="resChoosDrop"
								text={this.props.t("resourceChooser.heading")}
							>
								<Dropdown.Menu className="grey">
									{!this.props.onlyDrivers && this.props.app.ui.modules.has("REQUEST_PLANNING") &&
									this.props.app.ui.rights.has("PLAN_REQUESTS") ? (
										<Dropdown.Item
											onClick={(_) =>
												this.props.app.ui.setRequirementMode(true)
											}
										>
											{this.props.t("requirementChooser.heading")}
										</Dropdown.Item>
									) : null}
								</Dropdown.Menu>
							</Dropdown>

							<Menu.Item>
								<Input
									className="icon"
									icon="search"
									placeholder={this.props.t("filter")}
									value={this.state.filter}
									onChange={(e, { value }) => this.changeFilter(value)}
								/>
							</Menu.Item>
							<Menu.Item
								name="showUnavailable"
								onClick={(e) =>
									this.setShowUnavailable(!this.state.showUnavailable)
								}
							>
								<Radio
									inverted="true"
									toggle
									className="inverted"
									checked={!this.state.showUnavailable}
									label={this.props.t("resourceChooser.onlyAvailable")}
								/>
							</Menu.Item>
							<Menu.Menu position="right">

								{this.state.processes.length > 1 ? (
									<Menu.Item 
										name="Select multiple" 
										active={this.state.multiMode}
										onClick={(e) => this.setMultiModeRes(!this.state.multiMode)}>
										<Icon name="clone" /> {this.props.t("calButtons.multiMode")}
									</Menu.Item>
								) : null} 

								<Menu.Item name="close it" onClick={(e) => this.props.close()}>
									<Icon name="close" /> {this.props.t("cancel")}
								</Menu.Item>
								<Menu.Item
									name="save it"
									onClick={(e) =>
										this.props.save(
											//this.state.jobs,
											//this.state.selected,
											this.state.initiallySelected,
											this.state.project,
											(this.props.onlyDrivers === true),
											this.state.selectedIndividualProcess
										)
									}
								>
									<Icon name="check" /> {this.props.t("ok")}
								</Menu.Item>
							</Menu.Menu>
						</Menu>
						<div className="outerProjectName">
							{this.state.project.fullName}
							{this.props.requirement.id !== false
								? " - " + this.props.requirement.name
								: ""}
						</div>
						<Modal.Content>

							{this.state.processes.length > 1 ? (
								<Menu secondary className="processChooserMenu">
									{this.state.processes.map(x => (
										<Menu.Item
											name={x.id}
											key={x.id}
											 /* active={x.id === this.state.currentProcess} */ 

											active={
												this.state.multiMode? this.state.selectedProcesses.includes(x.id):x.id === this.state.currentProcess
											}
											
											onClick={_ => this.setCurrentProcess(x.id)}
										>
											<i
												className={
													x.template && x.template.icon
														? " picon picon-" + x.template.icon
														: ""
												}
											/>{" "}
											{x.name}
										</Menu.Item>
									))}
								</Menu>
							) : null}	

							<div className="resourceChooserWrapper"> 

								{/* Booked Resources */}
								{this.state.selectedIndividualProcess[this.state.currentProcess]['resources'] ? 
									<div className={"resc_classwrapper  compactmode"}>
										<div className="resc_classname">
											<Button>
											{this.props.t("resourceChooser.bookedResources")}
											</Button> 
										</div>
										<div className="resc_wrapper" >
											{this.props.app.resources.list().map((c) => {
												if (
													this.state.selectedClass !== "" &&
													this.state.selectedClass !== c.resClass.id
												)
													return null;   
												if(this.props.onlyDrivers){
													if((!c.resClass.human) || !((c.resClass.name ?? "").toLowerCase().startsWith('chauffeurs'))){
														return null;
													}
												}										
												resourcesBooked = c.res
													.map((r) => {
														if (
															!this.state.resourceInformation.has(
																c.resClass.id + "#" + r.id
															) ||
															!filter([
																r.name,
																"" + r.inventaryNumber,
																c.resClass.name ? c.resClass.name : "",
															])
														)
															return null;
														
														const isAvailable = this.state.resourceInformation.has(
															c.resClass.id + "#" + r.id
														)
															? this.state.resourceInformation.get(
																	c.resClass.id + "#" + r.id
															).isAvailable
															: true;

														const borderColor = this.state.resourceInformation.has(
															c.resClass.id + "#" + r.id
														)
															? this.state.resourceInformation.get(
																	c.resClass.id + "#" + r.id
															).borderColor
															: null;

														const marked = (this.state.selectedIndividualProcess[this.state.currentProcess]['resources'].includes(
																c.resClass.id + "#" + r.id
														)
															? " marked"
															: "");

														if (!isAvailable && !this.state.showUnavailable) { 
															return false;
														}

														if (!this.state.selectedIndividualProcess[this.state.currentProcess]['resources'].includes(
															c.resClass.id + "#" + r.id
														))
															return null;

														return (
															<div
																key={r.id}
																className={
																	"resc_res" +
																	marked
																	+
																	(isAvailable ? "" : " unavailable")
																}
																onClick={(e) => this.toggle(e, c.resClass.id, r.id, marked)}
															> 
																<div
																	className={
																		"resc_image" +
																		(c.resClass.id === "GROUP"
																			? " resc_group picon picon-group"
																			: "") +
																		(borderColor ? " absenceBorder" : "")
																	}
																	style={
																		borderColor ? {
																			borderColor: borderColor
																		} : null
																	}
																>
																	<div
																		className="resc_image_background"
																		style={
																		c.resClass.id === "GROUP"
																			? null
																			: {
																					backgroundImage: "url(" + r.imageUrl + ")",
																			}
																		}
																	/>
																</div>
																<div className="resc_name">{r.name} <br/>({c.resClass.name})</div>
															</div>
														);
													})
													.filter((x) => x);

												if (!resourcesBooked.length) {
													return null;
												}		
												
												return (
													<>{resourcesBooked}</>  
												); 

											})}
										</div>
									</div>
									: "" 
								} 

								{this.props.app.resources.list().map((c) => {
									if (
										this.state.selectedClass !== "" &&
										this.state.selectedClass !== c.resClass.id
									)
										return null;
									const scrollRef = createRef();
									const order = [];
									let skipped = 0;
									if(this.props.onlyDrivers){
										if((!c.resClass.human) || !((c.resClass.name ?? "").toLowerCase().startsWith('chauffeurs'))){
											return null;
										}
									}
									
									let rescomps = c.res
										.map((r) => { 
											
											if (
												!this.state.resourceInformation.has(
													c.resClass.id + "#" + r.id
												) ||
												!filter([
													r.name,
													"" + r.inventaryNumber,
													c.resClass.name ? c.resClass.name : "",
												])
											)
												return null;
											order.push(c.resClass.id + "#" + r.id);
											const isAvailable = this.state.resourceInformation.has(
												c.resClass.id + "#" + r.id
											)
												? this.state.resourceInformation.get(
														c.resClass.id + "#" + r.id
												  ).isAvailable
												: true;

											const borderColor = this.state.resourceInformation.has(
												c.resClass.id + "#" + r.id
											)
												? this.state.resourceInformation.get(
														c.resClass.id + "#" + r.id
												  ).borderColor
												: null;

											const marked = (this.state.selectedIndividualProcess[this.state.currentProcess]['resources'].includes(
												c.resClass.id + "#" + r.id
											)
												? " marked"
												: "");

											if (!isAvailable && !this.state.showUnavailable) {
												skipped++;
												return false;
											} 											

											return (
												<div
													key={r.id}
													className={
														"resc_res" +
														marked +
														(isAvailable ? "" : " unavailable") + 
														(
															( this.state.showFilerRollerRadio ) &&
															this.state.rollerShowDefault.length && 
															c?.resClass?.name?.toLowerCase() === "walzen" &&
															this.state.rollerShowDefault.includes(r.id)
															? " roller_res_show"
															: this.state.showFilerRollerRadio && 
															!this.state.filterRoller &&
															c?.resClass?.name?.toLowerCase() === "walzen"
															? " roller_res_show"
															: this.state.showFilerRollerRadio &&
															c?.resClass?.name?.toLowerCase() === "walzen"
															? " roller_res_hide"
															: ""
														)
													}
													onClick={(e) => this.toggle(e, c.resClass.id, r.id, marked)}
												> 													
													<div
														className={
															"resc_image" +
															(c.resClass.id === "GROUP"
																? " resc_group picon picon-group"
																: "") +
															(borderColor ? " absenceBorder" : "")
														}
														style={
															borderColor ? {
																borderColor: borderColor
															} : null
														}
													>
														<div
															className="resc_image_background"
															style={
															c.resClass.id === "GROUP"
																? null
																: {
																		backgroundImage: "url(" + r.imageUrl + ")",
																  }
															}
														 />
													</div>
													<div className="resc_name">{r.name}</div>
												</div>
											);
										})
										.filter((x) => x);

									if (c.resClass.id in rentalResources) {
										for (let r of rentalResources[c.resClass.id].values()) {
											const contextRef = createRef();
											const marked = (this.state.selectedIndividualProcess[this.state.currentProcess]['resources'].includes("RENT#" + r.id)
											? " marked"
											: "");
											rescomps.push(
												<div
													key={r.id}
													className={
														"resc_res" +
														marked
													}
													onClick={(e) => this.toggle(e, "RENT", r.id, marked)}
												>
													<div className="resc_image rental" ref={contextRef}>
														<div className="bigM">
															{this.props
																.t("resourceChooser.rent")
																.substr(0, 1)}
														</div>
														{this.props.app.ui.rights.has("CREATE_RENTALS") ? (
															<AddRentalResource
																key="rent"
																name={r.name}
																rentId={r.id}
																ctxref={contextRef}
																supplier={r.supplier.id}
																trigger={
																	<div className="rentalEdit ignore">
																		<Icon name="pencil" className="ignore" />
																	</div>
																}
																onSave={this.saveRentalResource}
															/>
														) : null}
													</div>
													<div className="resc_name">{r.name}</div>
												</div>
											);
										}
									}

									/*if ((rescomps.length + skipped) > 0) {
										rescomps.push(
											<AddRentalResource key="rent" trigger={<div
												
												className={"resc_res rent"}
											>
												<div
													className="resc_image"
												
												><Icon name="plus" /></div>
												<div className="resc_name">
													{this.props.t(
														"resourceChooser.forRent"
													)}
												</div>
											</div>} />
										);
									}*/

									if (
										false &&
										rescomps.length + skipped > 0 &&
										!c.resClass.human
									) {
										rescomps.push(
											<div
												key="nagel"
												className={"resc_res nagel"}
												onClick={(e) => this.nagel(c.resClass.name)}
											>
												<div
													className="resc_image"
													style={{
														backgroundImage: `url(${Nagel})`,
													}}
												/>
												<div className="resc_name">
													{this.props.t("resourceChooser.rent")}
												</div>
											</div>
										);
									}

									if (!rescomps.length) {
										return null;
									}    

									let pos = this.state.activeMap
										? order.indexOf(this.state.activeMap)
										: -1;
									if (!compactmode && pos > -1) {
										const insertPos = Math.floor(pos / 5) * 5 + 5;
										rescomps.splice(
											insertPos,
											0,
											<ResMapDetail
												key="rema"
												process={this.state.jobs[0]?.process.name}
												bpo={this.state.jobs[0]?.bpo}
												data={this.state}
												marker={this.state.marker}
												resourceClass={c.resClass}
												resourceKey={this.state.activeMap}
												deploymentDetails={this.state.deploymentDetails}
												position={this.state.position}
												information={
													this.state.resourceInformation.has(
														this.state.activeMap
													)
														? this.state.resourceInformation.get(
																this.state.activeMap
														  )
														: null
												}
											/>
										);
									} 

									return (
										<div
											key={c.resClass.id}
											className={
												"resc_classwrapper" +
												(compactmode ? " compactmode" : "")
											}
										>
											<div className="resc_classname">
												<Button
													color={
														this.state.selectedClass === c.resClass.id
															? "grey"
															: null
													}
													onClick={() => this.selectClass(c.resClass.id)}
													icon
													labelPosition="left"
												>
													{c.resClass.id === "GROUP"
														? this.props.t("resourceChooser.groups")
														: c.resClass.name}
													<Icon name="filter" />
												</Button>

												{	c.resClass.id !== "GROUP" && 
													c.resClass.name.toLowerCase() === "walzen" && 
													this.state.showFilerRollerRadio ?
													(
														<div className="roller_request_filter_radio">
															<Radio 
																inverted="true"
																toggle
																className="inverted"
																checked={this.state.filterRoller}
																label="Filter roller"
																onChange={() => {
																	this.setState({
																		filterRoller: !this.state.filterRoller
																	});
																}}	
															/>
														</div>
													) : null
												}

												{c.resClass.id === "GROUP" ||
												!this.props.app.ui.rights.has(
													"CREATE_RENTALS"
												) ? null : (
													<AddRentalResource
														key="rent"
														resClass={c.resClass.id}
														scrollRef={scrollRef}
														trigger={
															<Button icon labelPosition="left">
																{this.props.t(
																	"resourceChooser.rentModal.button"
																)}
																<Icon name="plus" />
															</Button>
														}
														onSave={this.saveRentalResource}
													/>
												)}
											</div>
											<div
												ref={scrollRef}
												className="resc_wrapper"
												onScroll={this.onScroll}
											>
												{rescomps}
											</div>
											{compactmode && pos > -1 ? (
												<ResMapDetail
													key="rema"
													bpo={this.state.jobs[0]?.bpo}
													process={this.state.jobs[0]?.process.name}
													data={this.state}
													marker={this.state.marker}
													resourceKey={this.state.activeMap}
													resourceClass={c.resClass}
													position={this.state.position}
													deploymentDetails={this.state.deploymentDetails}
													information={
														this.state.resourceInformation.has(
															this.state.activeMap
														)
															? this.state.resourceInformation.get(
																	this.state.activeMap
															  )
															: null
													}
												/>
											) : null}
										</div>
									);
								})}
							</div>
						</Modal.Content>
					</React.Fragment>
				)}
			</Modal>
		);
	}
}

export default withTranslation()(inject("app")(observer(ResourceChooser)));
